export default [
    // 转运计划（客户端）
    {
        path: "transferplan/list",
        name: "transferPlanList",
        component: () => import(/* webpackTrunkName: "transferplan" */ "@/views/transferplan/index")
    },
    // 转运计划详情页
    {
        path: "transferplan/update/:type",
        name: "transferPlanUpdate",
        component: () => import(/* webpackChunkName: "transferplan" */ "@/views/transferplan/update")
    },
    // 转运计划（管理端）
    {
        path: "transferplan/admin/list",
        name: "transferPlanAdminList",
        component: () => import(/* webpackChunkName: "transferplan" */ "@/views/transferplan/admin/index")
    },
    {
        path: "transferplan/admin/update/:type",
        name: "transferPlanAdminUpdate",
        component: () => import(/* webpackChunkName: "transferplan" */ "@/views/transferplan/update")
    },
    // 转运入库单列表
    {
        path: "transferplan/inbound/list",
        name: "transferPlanInboundList",
        component: () => import(/* webpackChunkName: "transferplan" */ "@/views/transferplan/inbound/index")
    },
    // 转运入库详情
    {  
        path: "transferplan/inbound/update/:type",
        name: "transferPlanInboundUpdate",
        component: () => import(/* webpackChunkName: "transferplan" */ "@/views/transferplan/inbound/update")
    },
    // 转运出库单列表
    {
        path: "transferplan/outbound/list",
        name: "transferPlanOutboundList",
        component: () => import(/* webpackChunkName: "transferplan" */ "@/views/transferplan/outbound/index")
    },
    // 转运出库详情
    {  
        path: "transferplan/outbound/update/:type",
        name: "transferPlanOutboundUpdate",
        component: () => import(/* webpackChunkName: "transferplan" */ "@/views/transferplan/outbound/update")
    },
]